import { listItemWrapper, pagedListWrapper } from '../../../api-client/wrappers'
import { createQuery } from '../../../api-client/wrappers/helpers'
import type { DeepPartial, Query } from '../../../api-client/wrappers/types'
import type { Starter } from '../../types/internal'
import type { Quiz, Question, Status, ResultQuizBody } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const { getItem: getQuiz } = listItemWrapper<Quiz>(apiClient, {
      path: `/api/v${version}/quizzes`
    })

    const quizzes = pagedListWrapper<'id', Quiz>()(apiClient, {
      path: `/api/v${version}/quizzes`,
      idKey: 'id'
    })

    return {
      getQuiz,
      quizzes,

      startQuiz: <T extends DeepPartial<Question> = Question>(
        id: Quiz['id'],
        query: Query = {}
      ) =>
        apiClient.post<T[]>(`/api/v${version}/quizzes/${id}/start`, {
          query: createQuery(query)
        }),

      resultQuiz: (id: Quiz['id'], body: ResultQuizBody) =>
        apiClient.post<Status>(`/api/v${version}/quizzes/${id}/result`, {
          body
        })
    }
  }
} satisfies Starter
